export default "/assets/images/the-basic-breather-crop.webp?7d28efb5e23c1b782d01abc6f6a017dc";